import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import React from 'react';
import "react-lightbox-pack/dist/index.css";
import PageLayout from '../PageLayout';
dayjs.locale('ru');
var _ = require('lodash');

export function Error404Element(props) {
	return (
		<div style={{
			backgroundColor: "white", padding: "0 15px", borderRadius: "4px", display: "flex",
			alignItems: "center",
			justifyContent: "center",
			height: "100%"
		}}>
			<div style={{ display: "flex", justifyContent: "center" }}>
				<div>
					<img style={{ width: "400px" }} src='/resources/404.webp' />
					<div style={{
						fontSize: "28px",
						fontWeight: "bold",
						textAlign: "center"
					}}>Ошибка</div>
					<div style={{
						fontSize: "22px",
						textAlign: "center"
					}}>Страница не найдена</div>
				</div>
			</div>
		</div>
	);
}

export default function Error404(props) {
	return (<PageLayout hideSider={true} hideBreadcrumbs={true} center={true}>
		<Error404Element />
	</PageLayout>);
}